<clr-modal [(clrModalOpen)]="show" [clrModalSize]="size">
    <h3 class="modal-title" [hidden]="!title" [innerHtml]="title"></h3>
    <div class="modal-body" [hidden]="!message" [innerHtml]="message"></div>
    <div class="modal-footer" [hidden]="!no && !yes">
        <button type="button" class="btn btn-outline-danger" (click)="runResolve(false)" [hidden]="!no" [innerHtml]="no"></button>
        <button type="button" class="btn btn-info-outline" (click)="runResolve(true)" [hidden]="!yes" [innerHtml]="yes"></button>
    </div>
</clr-modal>